import { render, staticRenderFns } from "./edit-wrapper.vue?vue&type=template&id=0a141c2f&"
import script from "./edit-wrapper.vue?vue&type=script&lang=js&"
export * from "./edit-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./edit-wrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports